import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendar,
  faSearch,
  faHeart as faProHeart,
  faFileInvoice,
  faFileChartLine,
  faCamcorder,
  faTimes,
  faPen,
  faEllipsisV,
  faEllipsisH,
  faLockAlt,
  faEnvelope,
  faBoxOpen,
  faPhone,
  faFileDownload,
  faFileUpload,
  faPencilAlt,
  faCog,
  faCopy,
  faSave,
  faTrash,
  faTrashAlt,
  faListUl,
  faText,
  faBalanceScaleLeft,
  faAlicorn,
  faFolderOpen,
  faLongArrowAltRight,
  faLongArrowDown,
  faHomeHeart,
  faCompass,
  faUsers,
  faChartBar,
  faWrench,
  faHandsHeart,
  faBars,
  faArrowRight,
  faArrowLeft,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faInfoCircle,
  faPlus,
  faFileSpreadsheet,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faLink,
  faFlagCheckered,
  faBallotCheck,
  faComments,
  faShoppingBag,
  faCloudUpload,
  faShareAlt,
  faRepeat,
  faEye,
  faEyeSlash,
  faCrosshairsSimple,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faHeart,
  faCircle,
  faFilePdf,
  faVideo,
  faMusic,
  faImage,
  faSort,
  faSortUp,
  faSortDown,
  faKey,
  faCheck,
  faFileWord,
  faPlug,
  faPlay,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
  faBallotCheck,
  faTimes,
  faSearch,
  faFileInvoice as IconDefinition,
  faFileChartLine as IconDefinition,
  faFileSpreadsheet,
  faCamcorder as IconDefinition,
  faCalendar,
  faPen,
  faEllipsisV,
  faEllipsisH,
  faLockAlt,
  faPencilAlt,
  faCog,
  faCopy,
  faSave,
  faTrash,
  faTrashAlt,
  faListUl,
  faText,
  faBalanceScaleLeft,
  faKey as IconDefinition,
  faAlicorn,
  faFolderOpen,
  faBoxOpen,
  faPhone,
  faHomeHeart,
  faCompass,
  faLongArrowAltRight,
  faLongArrowDown,
  faUsers,
  faChartBar,
  faWrench,
  faHandsHeart,
  faBars,
  faArrowRight,
  faArrowLeft,
  faPlus,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faLink,
  faFlagCheckered,
  faPlay as IconDefinition,
  faHeart as IconDefinition,
  faProHeart as IconDefinition,
  faCircle as IconDefinition,
  faFilePdf as IconDefinition,
  faVideo as IconDefinition,
  faEnvelope as IconDefinition,
  faFileDownload as IconDefinition,
  faFileUpload as IconDefinition,
  faChevronUp as IconDefinition,
  faChevronDown as IconDefinition,
  faChevronLeft as IconDefinition,
  faChevronRight as IconDefinition,
  faInfoCircle as IconDefinition,
  faMusic as IconDefinition,
  faImage as IconDefinition,
  faSort as IconDefinition,
  faSortUp as IconDefinition,
  faSortDown as IconDefinition,
  faCheck as IconDefinition,
  faFileWord as IconDefinition,
  faPlug as IconDefinition,
  faComments as IconDefinition,
  faShoppingBag as IconDefinition,
  faCloudUpload as IconDefinition,
  faShareAlt as IconDefinition,
  faRepeat as IconDefinition,
  faEye as IconDefinition,
  faEyeSlash as IconDefinition,
  faCrosshairsSimple as IconDefinition
);
